import React from 'react';

export default () => (
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 12.5C9.31372 12.5 12 9.81372 12 6.5C12 3.18628 9.31372 0.5 6 0.5C2.68628 0.5 0 3.18628 0 6.5C0 9.81372 2.68628 12.5 6 12.5ZM9.7576 5.22534L5.30598 9.67695C5.1548 9.82811 4.90972 9.82811 4.75853 9.67693L2.2424 7.1608C2.09124 7.00964 2.09124 6.76453 2.2424 6.61337L2.78983 6.06594C2.94102 5.91478 3.18612 5.91478 3.33728 6.06594L5.03226 7.76092L8.66272 4.13048C8.8139 3.9793 9.05901 3.9793 9.21017 4.13048L9.7576 4.67791C9.90876 4.82907 9.90876 5.07418 9.7576 5.22534Z"
      fill="#D40F7D"
    />
  </svg>
);
